module.exports = __webpack_public_path__ + "images/fa-cfa-review-4.webp";